import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

const messages = {
    pl: {
        calendar: "Terminarz",
        reserveRace: "Rezerwuj",
        notice: 'Rezerwacja miejsca jest ważna do 15 minut przed terminem startu wybranej sesji',
        details: "Szczegóły",
        startList: "Lista startowa",
        registrationForm: "Formularz rejestracyjny",
        fullName: "Imię i nazwisko",
        selectSession: "Wybierz sesję",
        selectGokart: "Wybierz gokart",
        save: "Zapisz",
        registrationInstructions: "Instrukcja zapisów",
        phone: "Telefon",
        mail: "E-mail",
        junior: "Juniorski",
        senior: "Seniorski",
        tandem: "Podwójny",
        minimumRule: "Przynajmniej jeden trening musi być wybrany",
        maximumRule: "Zmniejsz liczbę wybranych treningów",
        overflowRule: "Jeden z treningów jest pełen",
        noGokartFreeRule: "Brak wolnych gokartów typu {gokart}",
        allCompetitions: "Wszystkie zawody",
        league: "Liga {league}",
    },
    en: {
        calendar: "Calendar",
        reserveRace: "Book a ride",
        notice: 'Seat reservation is valid until 15 minutes before the start time of the selected session',
        details: "Details",
        startList: "Start list",
        registrationForm: "Registration form",
        fullName: "Full name",
        selectSession: "Select a session",
        selectGokart: "Select gokart type",
        save: "Save",
        registrationInstructions: "Enrollment instructions",
        phone: "Phone",
        mail: "E-mail",
        junior: "Junior",
        senior: "Senior",
        tandem: "Tandem",
        minimumRule: "At least one training must be selected",
        maximumRule: "Reduce the number of selected trainings",
        overflowRule: "One of the trainings is full",
        noGokartFreeRule: "No free gokarts of the type {gokart}",
        allCompetitions: "All leagues",
        league: "{league} league",
    }
}
export default new VueI18n({
    locale: navigator.language,
    fallbackLocale: 'en',
    messages
})
